export default "__VITE_ASSET__mSRnfCQm__"